module.exports = __webpack_public_path__ + "static/media/pail-2.22860f02.png";